<template>
    <div>
        <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs">
            <div class="flex-grid__item">
                <div>
                    <h2>
                        Interim Payments
                    </h2>
                </div>
                <p v-if="interimPayments.length === 0">
                    Add details of any Interim Payments using the button below:
                </p>
                <div v-for="(interimPayment, index) in interimPayments" class="dependant a-form-inputs--section">
                    <payment :index="index"></payment>
                </div>
                <div class="flex-grid__g-8">
                    <button class="a-button" @click="addPayment">Add Interim Payment</button>
                </div>
            </div>

            <div class="flex-grid__item flex-grid--space-left">
                <div class="a-form-inputs">
                    <div>
                        <h2>
                            Interest
                        </h2>
                    </div>
                    <control label="Calculate Interest Rates to">
                        <select v-model="interestType" @change="calcInterestValue">
                            <option value="today">Today</option>
                            <option value="assumed_settlement">Assumed Settlement</option>
                            <option value="custom">Custom</option>
                            <option value="none">Do Not Calculate</option>
                        </select>
                    </control>
                    <control label="Custom date" for="custom_interest_date" v-if="interestType === 'custom'">
                        <date-input v-model="customInterestDate" @input="calcInterestValue"></date-input>
                        <control-error :show="!isValidDate()">
                            Date is required, must be in the format DD/MM/YYYY, be after the deceased's date of death
                            ({{ deceasedDod }})
                        </control-error>
                    </control>

                    <div class="a-table--short-no-style">
                        <div class="m-div-table__holder m-div-table__holder--less-margin">
                            <interest-item
                                    @update="onUpdate"
                                    :payload="payload"
                                    :interest="value('pastDependencyOnIncomeInterest')"
                                    :option="{name: 'pastDependencyOnIncome'}"
                                    :unique-id="uniqueId"
                                    :value="value('pastDependencyOnIncomeWithInterest')"
                                    tip-name="past_dependency_on_income"
                                    title="Past Dependency on Income"
                                    updates="pastDependencyOnIncomeInterest">
                            </interest-item>
                            <interest-item
                                    @update="onUpdate"
                                    :payload="payload"
                                    :interest="value('pastDependencyOnServicesInterest')"
                                    :option="{name: 'pastDependencyOnServices'}"
                                    :unique-id="uniqueId"
                                    :value="value('pastDependencyOnServicesWithInterest')"
                                    tip-name="past_dependency_on_services"
                                    title="Past Dependency on Services"
                                    updates="pastDependencyOnServicesInterest">
                            </interest-item>
                            <interest-item
                                    :interest="value('generalDamagesInterest')"
                                    :option="{name: 'generalDamages'}"
                                    :payload="payload"
                                    :unique-id="uniqueId"
                                    :value="value('generalDamagesWithInterest')"
                                    tip-name="general_damages_psla"
                                    title="General damages (PSLA)"
                                    updates="generalDamages">
                            </interest-item>
                            <interest-item
                                    @update="onUpdate"
                                    :payload="payload"
                                    :interest="value('bereavementAwardInterest')"
                                    :option="{name: 'bereavementAward'}"
                                    :unique-id="uniqueId"
                                    :value="value('bereavementAwardWithInterest')"
                                    tip-name="bereavement_award"
                                    title="Bereavement Award"
                                    updates="bereavementAwardInterest">
                            </interest-item>
                            <interest-item
                                    @update="onUpdate"
                                    :payload="payload"
                                    :interest="value('funeralExpensesInterest')"
                                    :option="{name: 'funeralExpenses'}"
                                    :unique-id="uniqueId"
                                    :value="value('funeralExpensesWithInterest')"
                                    tip-name="funeral_expenses"
                                    title="Funeral Expenses"
                                    updates="funeralExpensesInterest">
                            </interest-item>
                            <interest-item
                                    @update="onUpdate"
                                    :payload="payload"
                                    :interest="value('lossOfSpouseInterest')"
                                    :option="{name: 'lossOfSpouse'}"
                                    :unique-id="uniqueId"
                                    :value="value('lossOfSpouseWithInterest')"
                                    tip-name="loss_of_spouse"
                                    title="Loss of Spouse"
                                    updates="lossOfSpouseInterest">
                            </interest-item>
                            <interest-item
                                    @update="onUpdate"
                                    :payload="payload"
                                    :interest="value('pastLossOfEarningsInterest')"
                                    :option="{name: 'pastLossOfEarnings'}"
                                    :unique-id="uniqueId"
                                    :value="value('pastLossOfEarningsWithInterest')"
                                    tip-name="past_loss_of_earnings"
                                    title="Past Loss of Earnings"
                                    updates="pastLossOfEarningsInterest">
                            </interest-item>
                            <interest-item
                                    @update="onUpdate"
                                    :payload="payload"
                                    :interest="value('pastCostOfCareInterest')"
                                    :option="{name: 'pastCostOfCare'}"
                                    :unique-id="uniqueId"
                                    :value="value('pastCostOfCareWithInterest')"
                                    tip-name="past_cost_of_care"
                                    title="Past Cost of Care"
                                    updates="pastCostOfCareInterest">
                            </interest-item>
                            <interest-item
                                    @update="onUpdate"
                                    :payload="payload"
                                    :interest="value('pastCostOfTravelInterest')"
                                    :option="{name: 'pastCostOfTravel'}"
                                    :unique-id="uniqueId"
                                    :value="value('pastCostOfTravelWithInterest')"
                                    tip-name="past_cost_of_travel"
                                    title="Past Cost of Travel"
                                    updates="pastCostOfTravelInterest">
                            </interest-item>
                            <interest-item
                                    @update="onUpdate"
                                    :payload="payload"
                                    :interest="value('miscInterest')"
                                    :option="{name: 'misc'}"
                                    :unique-id="uniqueId"
                                    :value="value('miscWithInterest')"
                                    tip-name="miscellaneous"
                                    title="Miscellaneous"
                                    updates="miscInterest">
                            </interest-item>
                            <interest-item
                                    @update="onUpdateCustom"
                                    :payload="payload"
                                    :interest="headOfLoss.interest"
                                    :option="{name: headOfLoss.name, key}"
                                    :title="headOfLoss.name"
                                    :unique-id="uniqueId"
                                    :updates="key"
                                    :value="headOfLoss.interestAccrued"
                                    :tip-name="headOfLoss.name"
                                    v-for="(headOfLoss, key) in headsOfLoss">
                            </interest-item>
                        </div>
                        <br/>
                    </div>
                </div>
            </div>
        </div>
        <step-button :next-valid="$valid() && allInterimPaymentsValid"></step-button>
        <modal :name="'interest_' + uniqueId" no-default-button="true">
            <modal-content></modal-content>
        </modal>
    </div>
</template>
<script>
    import _ from 'lodash';
    import Vue from 'vue';
    import moment from 'moment';
    import {mapGetters, mapActions} from 'vuex';
    import StepButton from 'components/StepButton.vue';
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import DateInput from 'components/form/control/DateInput.vue';
    import {setStepValid} from 'services/routingMethods';
    import FormValidator from 'components/form/validator/mixin';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import Payment from 'pages/fatal-accident-claims/dependency/steps/interim/Payment.vue';
    import Modal from 'components/modal/Modal.vue';
    import ModalContent from 'components/modal/ModalContent.vue';
    import InterestItem from 'components/InterestItem.vue';

    export default {
        name: 'InterimPaymentsAndInterest',
        computed: {
            ...mapGetters('fatal/dependency/headsOfLoss', ['value', 'headsOfLoss', 'getModalPayload']),
            ...mapGetters('fatal/dependency/interimPayments', ['interimPayments', 'allInterimPaymentsValid']),
            ...mapGetters('fatal/dependency/dependencyOnIncome', {
                incomePre: 'preDependencyValue',
                incomePost: 'postDependencyValue'
            }),
            ...mapGetters('fatal/dependency/deceased', {
                deceasedValue: 'theDeceased'
            }),
            deceasedDod: {
                get() {
                    return this.deceasedValue['dateOfDeath'];
                },
            },
            interestType: {
                get() {
                    return this.value('interestType');
                },
                set(value) {
                    this.setValue({key: 'interestType', value});
                }
            },
            customInterestDate: {
                get() {
                    return this.value('customInterestDate');
                },
                set(value) {
                    this.setValue({key: 'customInterestDate', value});
                }
            },
            payload: {
                get() {
                    return this.getModalPayload;
                },
            },
            uniqueId() {
                return this._uid;
            }
        },
        created() {
            setStepValid(true);
            this.calcInterestValue();
        },
        mixins: [
            FormValidator
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        components: {
            StepButton,
            Control,
            ControlError,
            DateInput,
            Payment,
            Modal,
            ModalContent,
            InterestItem
        },
        methods: {
            ...mapActions('fatal/dependency/headsOfLoss', {
                setValue: 'updateValue',
                updateInterest: 'calcNewValue',
                calcAllInterest: 'calcAllInterest',
                updateHeadOfLossValue: 'updateHeadOfLossValue'
            }),
            ...mapActions('fatal/dependency/interimPayments', ['addPayment']),
            calcInterestValue() {
                this.calcAllInterest();
            },
            onUpdate(info) {
                this.setValue({key: info.updates, value: info.value})
                    .then(this.calcAllInterest.bind(this));
            },
            onUpdateCustom(info) {
                this.updateHeadOfLossValue({index: info.updates, value: info.value, key: 'interest'})
                    .then(this.calcAllInterest.bind(this));
            },
            isValidDate() {
                let mDate = moment(this.customInterestDate, 'DD/MM/YYYY');
                return (
                    mDate.isValid()
                    && mDate.isAfter(moment(this.deceasedDod, 'DD/MM/YYYY'))
                );
            }
        }
    }
</script>



// WEBPACK FOOTER //
// InterimPaymentsAndInterest.vue?f10163f0